<!-- ヘッダー部分 -->
<div class="title-area">
  <h2 class="title">イベント検索</h2>
  <!-- 件数表示 -->
  @if (masterLoaded) {
    <div class="results-count">
      <span class="count-text">
        <span class="count-highlight">{{ totalCount }}</span>件中　{{ displayFrom }}-{{ displayTo }}件表示
      </span>
    </div>
  }
</div>

<!-- 検索・絞込 -->
<div class="tab-filter-area-container">
  @if (masterLoaded) {
    <app-event-search-filter
      [masterData]="MasterData"
      (search)="onFilterSearch($event)">
    </app-event-search-filter>
  }
</div>

<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <!-- 承認タブ -->
  <table class="event-table approval-table">
    <thead>
      <tr>
        <th class="col-document-type">帳票</th>
        <th class="col-drafter">起票者</th>
        <th class="col-event">イベント</th>
        <th class="col-unit">開催単位</th>
        <th class="col-participants">参加人数</th>
        <th class="col-participant-eval">参加者評価</th>
        <th class="col-scope">コピー</th>
        <th class="col-dates">開催日</th>
      </tr>
    </thead>
    <tbody>
      @for (event of approvalEvents; track event.id) {
        <tr>
          <!-- 帳票 -->
          <td class="col-document-type">
            <div class="document-type-content">
              <span>{{ getDocumentTypeLabel(event.documentType, event.status) }}</span>
            </div>
          </td>

          <!-- 起票者 -->
          <td class="col-drafter">
            <!-- 役職・名前の下に間隔をあけて担当（支部・部署）を並べる。
                 他組織は「他組織」・業種・従業員規模（人数）の順 -->
            <div class="drafter-content">
              @if (event.otherCompany) {
                <div class="drafter-line">他組織</div>
                <div class="drafter-line">{{ getIndustryLargeLabel(event.industryLarge) }}</div>
                <div class="drafter-line">{{ getEmployeeSizeLabel(event.employeeSize) }}</div>
              } @else {
                @if (event.drafter.position) {
                  <div class="drafter-line drafter-position">{{ event.drafter.position }}</div>
                }
                @if (event.drafter.name) {
                  <div class="drafter-line drafter-name">{{ event.drafter.name }}</div>
                }
                @if (event.drafter.branch) {
                  <div class="drafter-line drafter-org">{{ event.drafter.branch }}</div>
                }
                @if (getDepartmentFromOrganizations(event)) {
                  <div class="drafter-line drafter-org">{{ event.drafter.organizations[0] }}</div>
                }
              }
            </div>
          </td>

          <!-- イベント -->
          <td class="col-event">
            <div class="event-content">
              @if (event.otherCompany) {
                <a class="event-title" (click)="onEventEXClick(event)">{{ event.title }}</a>
              } @else{
                <a class="event-title" (click)="onEventClick(event)">{{ event.title }}</a>
              }
              <div class="event-category">{{ event.category }}</div>
              <!-- 概要：1440px以上は116文字、1024〜1439pxは50文字まで -->
              <div class="event-description desc-long">{{ getTruncatedDescription(event.description) }}</div>
              <div class="event-description desc-short">{{ getTruncatedDescription(event.description, 50) }}</div>
            </div>
          </td>

          <!-- 開催単位 -->
          <td class="col-unit">
            @for (part of splitHoldingUnit(event.holdingUnit); track $index; let last = $last) {
              <span class="unit-part">{{ part }}</span>@if (!last) {<span class="unit-sep">/</span>}
            }
          </td>

          <!-- 参加人数 -->
          <td class="col-participants">
            <div class="participants-content">
              @if (event.participantCount !== null) {
                <div class="number-with-unit">
                  <span class="participant-count">{{ event.participantCount }}</span>
                  <span class="unit">人</span>
                </div>
                @if (event.coverageRate !== null) {
                  <div class="coverage-rate">
                    <span class="coverage-label">カバー率</span>
                    <span class="coverage-value">{{ event.coverageRate }} %</span>
                  </div>
                }
              } @else {
                <span>-</span>
              }
            </div>
          </td>

          <!-- 参加者評価 -->
          <td class="col-participants">
            <div class="participants-content">
              @if (event.participantEvalScore !== null) {
                <div class="number-with-unit">
                  <span class="participant-count">{{ getMasterName('report_eval_score', event.participantEvalScore) }}</span>
                </div>
                @if (getCollectionRate(event) !== null) {
                  <div class="coverage-rate">
                    <span class="coverage-label">収集率</span>
                    <span class="coverage-value">{{ getCollectionRate(event) }}</span>
                  </div>
                }
              } @else {
                <span>-</span>
              }
            </div>
          </td>

          <!-- コピー回数 -->
          <!-- コピー回数：今後実装予定のため、今は0回と表示する -->
          <td class="col-scope">0回</td>

          <!-- 開催日など -->
          <td class="col-dates">
            <div class="dates-content">

              @for (date of getDisplayDates(event); track $index) {
                <div class="event-date">{{ date }}</div>
              }

              @if (hasMoreDates(event)) {
                <div class="more-dates">など</div>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>

  <!-- タブレット・SP（1023px以下）用：1件1枚のカード（表は非表示） -->
  <div class="event-cards">
    @for (event of approvalEvents; track event.id) {
      <div class="event-card">
        <!-- カード上部：帳票・カテゴリー、イベント名（概要は表示しない） -->
        <div class="card-head">
          <div class="card-tags">
            <span class="card-doc-type">{{ getDocumentTypeLabel(event.documentType, event.status) }}</span>
            <span class="event-category">{{ event.category }}</span>
          </div>
          @if (event.otherCompany) {
            <a class="event-title" (click)="onEventEXClick(event)">{{ event.title }}</a>
          } @else {
            <a class="event-title" (click)="onEventClick(event)">{{ event.title }}</a>
          }
        </div>
        <div class="card-body">
          <div class="card-label">開催単位</div>
          <div class="card-value">{{ event.holdingUnit }}</div>

          <div class="card-label">参加人数</div>
          <div class="card-value">
            <!-- 人数とカバー率の間は8px（空白文字は入れず、余白で空ける） -->
            @if (event.participantCount !== null) {
              <span>{{ event.participantCount }}人</span>
              @if (event.coverageRate !== null) {
                <span class="card-sub card-rate">カバー率 {{ event.coverageRate }} %</span>
              }
            } @else {
              -
            }
          </div>

          <div class="card-label">参加者評価</div>
          <div class="card-value">
            <!-- 評価と収集率の間は8px（空白文字は入れず、余白で空ける） -->
            @if (event.participantEvalScore !== null) {
              <span>{{ getMasterName('report_eval_score', event.participantEvalScore) }}</span>
              @if (getCollectionRate(event) !== null) {
                <span class="card-sub card-rate">収集率 {{ getCollectionRate(event) }}</span>
              }
            } @else {
              -
            }
          </div>

          <!-- 開催日：4日以上ある場合は3つ目の日付の右に「など」。期間は「〇〇から」「〇〇まで」の2行 -->
          <div class="card-label">開催日</div>
          <div class="card-value">
            @for (date of getCardDisplayDates(event); track $index; let last = $last) {
              <div class="event-date">{{ date }}@if (last && hasMoreDates(event)) {<span class="more-dates-inline">など</span>}</div>
            }
          </div>

          <!-- 起票者：役職・名前・担当の順で1行ずつ（他組織は「他組織」・業種・従業員規模（人数）の順） -->
          <div class="card-label">起票者</div>
          <div class="card-value card-drafter">
            @if (event.otherCompany) {
              <div>他組織</div>
              <div>{{ getIndustryLargeLabel(event.industryLarge) }}</div>
              <div>{{ getEmployeeSizeLabel(event.employeeSize) }}</div>
            } @else {
              @if (event.drafter.position) {
                <div>{{ event.drafter.position }}</div>
              }
              @if (event.drafter.name) {
                <div>{{ event.drafter.name }}</div>
              }
              @if (event.drafter.branch) {
                <div>{{ event.drafter.branch }}</div>
              }
              @if (getDepartmentFromOrganizations(event)) {
                <div>{{ event.drafter.organizations[0] }}</div>
              }
            }
          </div>

          <!-- コピー回数：今後実装予定のため、今は0回と表示する -->
          <div class="card-label">コピー</div>
          <div class="card-value">0回</div>
        </div>
      </div>
    }
  </div>

  <!-- ページング -->
  <div class="custom-pagination">
    <div class="pagination-container">

      @if (approvalEvents.length > 0) {

        @if (isFirstPage()) {
          <div class="paging-step paging-step-disable">
            <img src="assets/common/ChevronLeft_gray.svg" alt="前へ">
          </div>
        } @else {
          <button class="paging-step" (click)="previous()">
            <img src="assets/common/ChevronLeft.svg" alt="前へ">
          </button>
        }

        @for (page of pages; track page) {
          <div>
            @if (page !== this.page) {
              <div
                class="paging-link-container"
                (click)="goPage(page)">
                <span class="paging-text">{{ page }}</span>
              </div>
            } @else {
              <div class="current-page">
                <span class="paging-text">{{ page }}</span>
              </div>
            }
          </div>
        }

        @if (isLastPage()) {
          <div class="paging-step paging-step-disable">
            <img src="assets/common/ChevronRight_gray.svg" alt="次へ">
          </div>
        } @else {
          <button class="paging-step" (click)="next()">
            <img src="assets/common/ChevronRight.svg" alt="次へ">
          </button>
        }

      }

    </div>
  </div>

    <!-- イベントがない場合 -->
    @if (approvalEvents.length === 0) {
      <div class="no-events">
        イベントがありません。
      </div>
    }
}
